<template>
    <v-app id="app_measurements">
        <v-overlay v-model="centerLoading" :scrim="false" class="custom_centered_overlay">
            <v-progress-circular color="#2A8200" indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-container fluid>

            <v-row class="d-flex align-center justify-space-between">
                <v-col class="mt-0" cols="7">
                    <p class="custom_page_main_title">OFFICERS ATTENDANCE ANALYSIS</p>
                    <p class="custom_page_main_sub_title" style="opacity: 0.6">
                        Used to analyze all the officers' attendance details.
                    </p>
                </v-col>

                <v-col class="px-4 mt-0 d-flex justify-end" cols="5">
                    <v-row class="custom_tool_bar_style align-center">
                        <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
                        <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute">
                            <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>



            <v-card class="pa-5 mt-5">
                <v-row justify="end">
                    <v-col cols="auto">
                        <v-btn class="custom_pdf_btn ml-4" variant="outlined" @click="exportPDF">
                            <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>

            <v-card class="pa-5 ">
                <v-row>

                    <v-col cols="12" md="4">
                        <v-autocomplete v-model="userCatagory" :items="userCatagaryItems" clearable item-title="name"
                            item-value="name" label="Oficer Type" multiple placeholder="All" variant="outlined"
                            density="comfortable" class="custom_input_field_color"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-autocomplete v-model="userCatagory" :items="userCatagaryItems" clearable item-title="name"
                            item-value="name" label="Oficer" multiple placeholder="Select Oficer" variant="outlined"
                            density="comfortable" class="custom_input_field_color"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-date-input v-model="dates" label="Select Date Range" prepend-icon=""
                            prepend-inner-icon="$calendar" multiple="range" variant="outlined" clearable
                            @click:clear="clearDateRange" density="comfortable" class="custom_input_field_color" />
                    </v-col>
                </v-row>

                <v-row>

                    <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                        <v-card class="mx-auto pa-4" elevation="0" border="sm opacity-1" rounded="md">
                            <p class="font-weight-bold custom_page_component_main_title">ON TIME OFFICERS</p>
                            <p class="custom_page_main_sub_title_very_small_red">LAST 30 DAYS</p>

                            <v-divider></v-divider>

                            <div class="mt-4">
                                <p class="text-h4 font-weight-bold text-primary">78 %</p>
                                <p class="text-green text-body-2 font-weight-medium">
                                    <v-icon size="16" color="green">mdi-arrow-up</v-icon>
                                    0.08% Increase than last 30 days
                                </p>
                            </div>
                        </v-card>
                    </v-col>

                    <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                        <v-card class="mx-auto pa-4" elevation="0" border="sm opacity-1" rounded="md">
                            <p class="font-weight-bold custom_page_component_main_title">LATE OFFICERS</p>
                            <p class="custom_page_main_sub_title_very_small_red">LAST 30 DAYS</p>

                            <v-divider></v-divider>

                            <div class="mt-4">
                                <p class="text-h4 font-weight-bold text-primary">31 %</p>
                                <p class="text-green text-body-2 font-weight-medium">
                                    <v-icon size="16" color="green">mdi-arrow-up</v-icon>
                                    0.08% Increase than last 30 days
                                </p>
                            </div>
                        </v-card>
                    </v-col>

                    <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                        <v-card class="mx-auto pa-4" elevation="0" border="sm opacity-1" rounded="md">
                            <p class="font-weight-bold custom_page_component_main_title">OVERTIME REQUEST</p>
                            <p class="custom_page_main_sub_title_very_small_red">LAST 30 DAYS</p>

                            <v-divider></v-divider>

                            <div class="mt-4">
                                <p class="text-h4 font-weight-bold text-primary">65 %</p>
                                <p class="text-green text-body-2 font-weight-medium">
                                    <v-icon size="16" color="green">mdi-arrow-up</v-icon>
                                    0.08% Increase than last 30 days
                                </p>
                            </div>
                        </v-card>
                    </v-col>

                    <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                        <v-card class="mx-auto pa-4" elevation="0" border="sm opacity-1" rounded="md">
                            <p class="font-weight-bold custom_page_component_main_title">ABSENTS OFFICERS</p>
                            <p class="custom_page_main_sub_title_very_small_red">LAST 30 DAYS</p>

                            <v-divider></v-divider>

                            <div class="mt-4">
                                <p class="text-h4 font-weight-bold text-primary">24 %</p>
                                <p class="text-green text-body-2 font-weight-medium">
                                    <v-icon size="16" color="green">mdi-arrow-up</v-icon>
                                    0.08% Increase than last 30 days
                                </p>
                            </div>
                        </v-card>
                    </v-col>




                </v-row>

                <v-card class="pa-5 mt-8">

                    <v-row>

                        <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                            <v-card class="mx-auto pa-4 d-flex align-center" elevation="0" border="sm opacity-1"
                                rounded="md">
                                <v-row no-gutters align="center">
                                    <v-col cols="auto">
                                        <v-icon size="16" :color="ON_TIME_OFFICERS_iconColor">mdi-square</v-icon>
                                    </v-col>
                                    <v-col>
                                        <p class="text-h6 font-weight-bold mb-0"
                                            :style="{ color: ON_TIME_OFFICERS_iconColor }">78</p>
                                        <p class="text-body-2 text-secondary font-weight-medium">ON TIME OFFICERS</p>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>



                        <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                            <v-card class="mx-auto pa-4 d-flex align-center" elevation="0" border="sm opacity-1"
                                rounded="md">
                                <v-row no-gutters align="center">
                                    <v-col cols="auto">
                                        <v-icon size="16" :color="LATE_OFFICERS_iconColor">mdi-square</v-icon>
                                    </v-col>
                                    <v-col>
                                        <p class="text-h6 font-weight-bold mb-0"
                                            :style="{ color: LATE_OFFICERS_iconColor }">78</p>
                                        <p class="text-body-2 text-secondary font-weight-medium">LATE OFFICERS</p>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                            <v-card class="mx-auto pa-4 d-flex align-center" elevation="0" border="sm opacity-1"
                                rounded="md">
                                <v-row no-gutters align="center">
                                    <v-col cols="auto">
                                        <v-icon size="16" :color="OVERTIME_REQUEST_iconColor">mdi-square</v-icon>
                                    </v-col>
                                    <v-col>
                                        <p class="text-h6 font-weight-bold mb-0"
                                            :style="{ color: OVERTIME_REQUEST_iconColor }">78</p>
                                        <p class="text-body-2 text-secondary font-weight-medium">OVERTIME REQUEST</p>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                            <v-card class="mx-auto pa-4 d-flex align-center" elevation="0" border="sm opacity-1"
                                rounded="md">
                                <v-row no-gutters align="center">
                                    <v-col cols="auto">
                                        <v-icon size="16" :color="ABSENTS_OFFICERS_iconColor">mdi-square</v-icon>
                                    </v-col>
                                    <v-col>
                                        <p class="text-h6 font-weight-bold mb-0"
                                            :style="{ color: ABSENTS_OFFICERS_iconColor }">78</p>
                                        <p class="text-body-2 text-secondary font-weight-medium">ABSENTS OFFICERS</p>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>

                    </v-row>

                    <div class="mt-10">
                        <BarChart />

                    </div>

                    <!-- <v-row align="center" justify="center">
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                            <div ref="chartdiv" style="width: 100%; height: 400px;" class="mt-2"></div>
                        </v-col>
                    </v-row> -->



                </v-card>

                <!-- ON TIME OFFICERS LIST TABLE -->

                <v-row class="align-center mt-10">
                    <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                        <div class="d-flex align-center flex-grow-1">
                            <p class="custom_page_component_main_title ma-0">ON TIME OFFICERS LIST</p>
                        </div>
                    </v-col>

                    <v-spacer></v-spacer>

                    <v-col cols="auto">
                        <v-btn class="custom_excel_btn" variant="outlined" @click="exportExcel">
                            <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
                        </v-btn>
                    </v-col>
                </v-row>

                <v-divider></v-divider>



                <v-data-table :group-by="groupBy" :headers="headers" :items="desserts" item-value="name">
                    <template v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen }">
                        <tr>
                            <td :colspan="columns.length">
                                <VBtn :icon="isGroupOpen(item) ? '$expand' : '$next'" size="small" variant="text"
                                    @click="toggleGroup(item)"></VBtn>
                                <div>
                                    <span class="text-muted">
                                        {{ item.value ? 'Mr. Tharindu Chandrasiri' : 'Mr. Ransilu Obeysekera' }}
                                    </span>
                                    <br />
                                    <span class="blue--text font-weight-bold">Reg num: {{ item.value ? '3566' : '9024'
                                    }}</span>
                                </div>
                            </td>
                        </tr>
                    </template>

                    <template v-slot:[`item.dayIn`]="{ item }">
                        <div >
                            <div>
                                <span>{{ item.dayIn.time }}</span> <br />
                                <span class="blue--text font-weight-bold">{{ item.dayIn.address }}</span>
                                <!-- Address in blue -->
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.dayOut`]="{ item }">
                        <div>
                            <span>{{ item.dayOut.time }}</span> <br />
                            <span class="blue--text font-weight-bold">{{ item.dayOut.address }}</span>
                            <!-- Address in blue -->
                        </div>
                    </template>
                </v-data-table>



                <!-- LAST TIME OFFICERS LIST TABLE -->

                <v-row class="align-center mt-10">
                    <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                        <div class="d-flex align-center flex-grow-1">
                            <p class="custom_page_component_main_title ma-0">LATE TIME OFFICERS LIST</p>
                        </div>
                    </v-col>

                    <v-spacer></v-spacer>

                    <v-col cols="auto">
                        <v-btn class="custom_excel_btn" variant="outlined" @click="exportExcel">
                            <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
                        </v-btn>
                    </v-col>
                </v-row>

                <v-divider></v-divider>


                <v-data-table :group-by="groupByLASTTIMEOFFICERS" :headers="LASTTIMEOFFICERSheaders" :items="LASTTIMEOFFICERSdesserts" item-value="name">
                    <template v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen }">
                        <tr>
                            <td :colspan="columns.length">
                                <VBtn :icon="isGroupOpen(item) ? '$expand' : '$next'" size="small" variant="text"
                                    @click="toggleGroup(item)"></VBtn>
                                <div>
                                    <span class="text-muted">
                                        {{ item.value ? 'Mr. Tharindu Chandrasiri' : 'Mr. Ransilu Obeysekera' }}
                                    </span>
                                    <br />
                                    <span class="blue--text font-weight-bold">Reg num: {{ item.value ? '3566' : '9024'
                                    }}</span>
                                </div>
                            </td>
                        </tr>
                    </template>

                    <template v-slot:[`item.dayIn`]="{ item }">
                        <div >
                            <div>
                                <span>{{ item.dayIn.time }}</span> <br />
                                <span class="blue--text font-weight-bold">{{ item.dayIn.address }}</span>
                                <!-- Address in blue -->
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.dayOut`]="{ item }">
                        <div>
                            <span>{{ item.dayOut.time }}</span> <br />
                            <span class="blue--text font-weight-bold">{{ item.dayOut.address }}</span>
                            <!-- Address in blue -->
                        </div>
                    </template>

                    <!-- Row Content -->
                    <!-- <template v-slot:item="{ item }">
                    <span class="blue--text">{{ item.dayIn }}</span>
                    </template> -->

                </v-data-table>


                <!--OVERTIME REQUEST OFFICERS LIST TABLE -->

                <v-row class="align-center mt-10">
                    <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                        <div class="d-flex align-center flex-grow-1">
                            <p class="custom_page_component_main_title ma-0">OVERTIME REQUEST OFFICERS LIST</p>
                        </div>
                    </v-col>

                    <v-spacer></v-spacer>

                    <v-col cols="auto">
                        <v-btn class="custom_excel_btn" variant="outlined" @click="exportExcel">
                            <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
                        </v-btn>
                    </v-col>
                </v-row>

                <v-divider></v-divider>

                <v-data-table :group-by="groupByRequestOfficers" :headers="headersByRequestOfficers"
                    :items="dessertsByRequestOfficers" item-value="name">
                    <template v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen }">
                        <tr>
                            <td :colspan="columns.length">
                                <VBtn :icon="isGroupOpen(item) ? '$expand' : '$next'" size="small" variant="text"
                                    @click="toggleGroup(item)"></VBtn>
                                <div>
                                    <span class="text-muted">
                                        {{ item.value ? 'Mr. Tharindu Chandrasiri' : 'Mr. Ransilu Obeysekera' }}
                                    </span>
                                    <br />
                                    <span class="blue--text font-weight-bold">Reg num: {{ item.value ? '3566' : '9024'
                                    }}</span>
                                </div>
                            </td>
                        </tr>
                    </template>

                    <template v-slot:[`item.dayIn`]="{ item }">
                        <div >
                            <div>
                                <span>{{ item.dayIn.time }}</span> <br />
                                <span class="blue--text font-weight-bold">{{ item.dayIn.address }}</span>
                                <!-- Address in blue -->
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.dayOut`]="{ item }">
                        <div>
                            <span>{{ item.dayOut.time }}</span> <br />
                            <span class="blue--text font-weight-bold">{{ item.dayOut.address }}</span>
                            <!-- Address in blue -->
                        </div>
                    </template>

                    <template v-slot:[`item.requestedHours`]="{ item }">
                        <div class="text-left">
                            <span class="blue--text "><strong class="black--text font-weight-bold">From:</strong> {{
                                item.requestedHours.from }}</span><br />
                            <span class="blue--text "><strong class="black--text font-weight-bold">To:</strong> {{ item.requestedHours.to
                            }}</span><br />
                            <span class="red--text "><strong class="black--text font-weight-bold">Hours:</strong> {{
                                item.requestedHours.hours }}</span>
                        </div>
                    </template>

                    <!-- Row Content -->
                    <!-- <template v-slot:item="{ item }">
                    <span class="blue--text">{{ item.dayIn }}</span>
                    </template>
                     -->
                </v-data-table>


                <!--ABSENTS OFFICERS LIST OFFICERS LIST TABLE -->

                <v-row class="align-center mt-10">
                    <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                        <div class="d-flex align-center flex-grow-1">
                            <p class="custom_page_component_main_title ma-0">ABSENTS OFFICERS LIST</p>
                        </div>
                    </v-col>

                    <v-spacer></v-spacer>

                    <v-col cols="auto">
                        <v-btn class="custom_excel_btn" variant="outlined" @click="exportExcel">
                            <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
                        </v-btn>
                    </v-col>
                </v-row>

                <v-divider></v-divider>

                <v-data-table :group-by="groupByAbsentsOfficers" :headers="headersByAbsentsOfficers"
                    :items="dessertsByAbsentsOfficers" item-value="name">
                    <template v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen }">
                        <tr>
                            <td :colspan="columns.length">
                                <VBtn :icon="isGroupOpen(item) ? '$expand' : '$next'" size="small" variant="text"
                                    @click="toggleGroup(item)"></VBtn>
                                <div>
                                    <span class="text-muted">
                                        {{ item.value ? 'Mr. Tharindu Chandrasiri' : 'Mr. Ransilu Obeysekera' }}
                                    </span>
                                    <br />
                                    <span class="blue--text font-weight-bold">Reg num: {{ item.value ? '3566' : '9024'
                                    }}</span>
                                </div>
                            </td>
                        </tr>
                    </template>


                    <!-- Row Content -->
                    <!-- <template v-slot:item="{ item }">
                    <span class="blue--text">{{ item.dayIn }}</span>
                    </template>
                     -->
                </v-data-table>


                <!--OFFICERS ON HALF DAY LEAVE TABLE -->

                <v-row class="align-center mt-10">
                    <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                        <div class="d-flex align-center flex-grow-1">
                            <p class="custom_page_component_main_title ma-0"> OFFICERS ON HALF DAY LEAVE</p>
                        </div>
                    </v-col>

                    <v-spacer></v-spacer>

                    <v-col cols="auto">
                        <v-btn class="custom_excel_btn" variant="outlined" @click="exportExcel">
                            <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
                        </v-btn>
                    </v-col>
                </v-row>

                <v-divider></v-divider>

                <v-data-table :group-by="groupByHalfDay" :headers="headersByHalfDay" :items="dessertsByHalfDay"
                    item-value="name">
                    <template v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen }">
                        <tr>
                            <td :colspan="columns.length">
                                <VBtn :icon="isGroupOpen(item) ? '$expand' : '$next'" size="small" variant="text"
                                    @click="toggleGroup(item)"></VBtn>
                                <div>
                                    <span class="text-muted">
                                        {{ item.value ? 'Mr. Tharindu Chandrasiri' : 'Mr. Ransilu Obeysekera' }}
                                    </span>
                                    <br />
                                    <span class="blue--text font-weight-bold">Reg num: {{ item.value ? '3566' : '9024'
                                    }}</span>
                                </div>
                            </td>
                        </tr>
                    </template>

                    <template v-slot:[`item.dayIn`]="{ item }">
                        <div >
                            <div>
                                <span>{{ item.dayIn.time }}</span> <br />
                                <span class="blue--text font-weight-bold">{{ item.dayIn.address }}</span>
                                <!-- Address in blue -->
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.dayOut`]="{ item }">
                        <div>
                            <span>{{ item.dayOut.time }}</span> <br />
                            <span class="blue--text font-weight-bold">{{ item.dayOut.address }}</span>
                            <!-- Address in blue -->
                        </div>
                    </template>

                    <template v-slot:[`item.date`]="{ item }">
                        <div>

                            <v-chip small outlined style="border: 1px solid #FFA500; color: #FF6347; background-color: transparent;">
                                       AFTERNOON-HD LEAVE
                                    </v-chip>
                                    <br />
                                    
                            <span>{{ item.dayOut.time }}</span> 
                        </div>
                    </template>

                    <!-- Custom Column for Date -->



                </v-data-table>





            </v-card>


        </v-container>
    </v-app>
</template>

<script setup>
import BarChart from "@/components/AttendanceManagement/BarChart.vue";
</script>
<script>
import { ref } from 'vue';
export default {

    data() {
        return {

            ON_TIME_OFFICERS_iconColor: ref('#4CAF50'),
            OVERTIME_REQUEST_iconColor: ref('#38ea15'),
            ABSENTS_OFFICERS_iconColor: ref('#f35814'),
            LATE_OFFICERS_iconColor: ref('#0920dd'),


            //  ON TIME OFFICERS LIST TABLE 
            
            groupBy: [
                {
                    key: 'gluten',
                    order: 'asc',
                },
            ],
            headers: [
                {
                    title: 'OFFICER NAME',
                    align: 'start',
                    sortable: false,
                    key: 'name',
                },
                { title: 'DAY IN', key: 'dayIn' },
                { title: 'DAY OUT', key: 'dayOut' },
                { title: 'WORKING HOURS', key: 'workingHours' },
                { title: 'DATE', key: 'date' },
            ],
            desserts: [
                {
                    officerName: "Mr. Tharindu Chandrasiri",
                    dayIn: { time: "8:23 AM", address: "No.22/1,  colombo" },
                    dayOut: { time: "4:55 PM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    workingHours: "9 hours 12 minutes",
                    date: "2025-01-01",
                    gluten: false,
                },
                {
                    officerName: "Mr. Ransilu Obeysekera",
                    dayIn: { time: "8:23 AM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    dayOut: { time: "4:55 PM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    workingHours: "8 hours 56 minutes",
                    date: "2025-01-03",
                    gluten: false,
                },
                {
                    officerName: "Mr. Ransilu Obeysekera",
                    dayIn: { time: "8:23 AM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    dayOut: { time: "4:55 PM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    workingHours: "9 hours 13 minutes",
                    date: "2025-01-04",
                    gluten: true,
                },

            ],

            // LAST TIME OFFICERS LIST TABLE

            groupByLASTTIMEOFFICERS: [
                {
                    key: 'gluten',
                    order: 'asc',
                },
            ],
            LASTTIMEOFFICERSheaders: [
                {
                    title: 'OFFICER NAME',
                    align: 'start',
                    sortable: false,
                    key: 'name',
                },
                { title: 'DAY IN', key: 'dayIn' },
                { title: 'DAY OUT', key: 'dayOut' },
                { title: 'WORKING HOURS', key: 'workingHours' },
                { title: 'DATE', key: 'date' },
            ],
            LASTTIMEOFFICERSdesserts: [
                {
                    officerName: "Mr. Tharindu Chandrasiri",
                    dayIn: { time: "8:23 AM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    dayOut: { time: "4:55 PM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    workingHours: "9 hours 12 minutes",
                    date: "2025-01-01",
                    gluten: false,
                },
                {
                    officerName: "Mr. Ransilu Obeysekera",
                    dayIn: { time: "8:23 AM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    dayOut: { time: "4:55 PM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    workingHours: "8 hours 56 minutes",
                    date: "2025-01-03",
                    gluten: false,
                },
                {
                    officerName: "Mr. Ransilu Obeysekera",
                    dayIn: { time: "8:23 AM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    dayOut: { time: "4:55 PM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    workingHours: "9 hours 13 minutes",
                    date: "2025-01-04",
                    gluten: true,
                },

            ],




            // OVERTIME REQUEST OFFICERS LIST TABLE
            groupByRequestOfficers: [
                {
                    key: 'gluten',
                    order: 'asc',
                },
            ],
            headersByRequestOfficers: [
                {
                    title: 'OFFICER NAME',
                    align: 'start',
                    sortable: false,
                    key: 'name',
                },
                { title: 'DAY IN', key: 'dayIn' },
                { title: 'DAY OUT', key: 'dayOut' },
                { title: 'ALL WORKING HR', key: 'AllworkingHr' },
                { title: 'REQUEST HOURS', key: 'requestedHours' },
                { title: 'TOTAL OF HOURS', key: 'TotalHours' },
                { title: 'DATE', key: 'date' },
            ],
            dessertsByRequestOfficers: [
                {
                    officerName: "Mr. Tharindu Chandrasiri",
                    dayIn: { time: "8:23 AM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    dayOut: { time: "4:55 PM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    AllworkingHr: "8 hours 56 minutes",
                    requestedHours: { from: "6:00 PM", to: "8:00 PM", hours: "02 Hours" },
                    TotalHours: "9 hours",
                    date: "2025-01-01",
                    gluten: false,
                },
                {
                    officerName: "Mr. Ransilu Obeysekera",
                    dayIn: { time: "8:23 AM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    dayOut: { time: "4:55 PM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    AllworkingHr: "8 hours 56 minutes",
                    requestedHours: { from: "6:00 PM", to: "8:00 PM", hours: "02 Hours" },
                    TotalHours: "9 hours",
                    date: "2025-01-01",
                    gluten: false,
                },
                {
                    officerName: "Mr. Ransilu Obeysekera",
                    dayIn: { time: "8:23 AM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    dayOut: { time: "4:55 PM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    AllworkingHr: "8 hours 56 minutes",
                    requestedHours: { from: "6:00 PM", to: "8:00 PM", hours: "02 Hours" },
                    TotalHours: "9 hours",
                    date: "2025-01-01",
                    gluten: true,
                },

            ],

            // ABSENTS OFFICERS LIST TABLE
            groupByAbsentsOfficers: [
                {
                    key: 'gluten',
                    order: 'asc',
                },
            ],
            headersByAbsentsOfficers: [
                {
                    title: 'OFFICER NAME',
                    align: 'start',
                    sortable: false,
                    key: 'name',
                },
                { title: 'DATE', key: 'date' },
            ],
            dessertsByAbsentsOfficers: [
                {
                    officerName: "Mr. Tharindu Chandrasiri",
                    date: "2025-01-01",
                    gluten: false,
                },
                {
                    officerName: "Mr. Ransilu Obeysekera",
                    date: "2025-01-03",
                    gluten: false,
                },
                {
                    officerName: "Mr. Ransilu Obeysekera",
                    date: "2025-01-04",
                    gluten: true,
                },

            ],

            // OVERTIME REQUEST OFFICERS LIST TABLE
            groupByHalfDay: [
                {
                    key: 'gluten',
                    order: 'asc',
                },
            ],
            headersByHalfDay: [
                {
                    title: 'OFFICER NAME',
                    align: 'start',
                    sortable: false,
                    key: 'name',
                },
                { title: 'DAY IN', key: 'dayIn' },
                { title: 'DAY OUT', key: 'dayOut' },
                { title: 'WORKING HOURS', key: 'workingHours' },
                { title: 'DATE', key: 'date' },
            ],
            dessertsByHalfDay: [
                {
                    officerName: "Mr. Tharindu Chandrasiri",
                    dayIn: { time: "8:23 AM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    dayOut: { time: "4:55 PM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    workingHours: "9 hours 12 minutes",
                    date: "2025-01-01",
                    gluten: false,
                },
                {
                    officerName: "Mr. Ransilu Obeysekera",
                    dayIn: { time: "8:23 AM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    dayOut: { time: "4:55 PM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    workingHours: "8 hours 56 minutes",
                    date: "2025-01-03",
                    gluten: false,
                },
                {
                    officerName: "Mr. Ransilu Obeysekera",
                    dayIn: { time: "8:23 AM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    dayOut: { time: "4:55 PM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    workingHours: "9 hours 13 minutes",
                    date: "2025-01-04",
                    gluten: true,
                },

            ],

            backPageRoute() {
      console.log("Going back AM Dashboad");
    }

        }
        


    },




}
</script>

<style scoped>
.blue--text {
    color: blue;
}

.red--text {
    color: red;
}

.black--text {
    color: black;
}

</style>